import { upload } from "@vercel/blob/client";
import { BACKEND_BASE_URL } from "./baseurl";

const normalizeBase = () => {
  const base = BACKEND_BASE_URL || "";
  return base.endsWith("/") ? base : `${base}/`;
};

export const getImageUploadUrl = () => `${normalizeBase()}api/image/upload`;

export const toUploadedFileMeta = (blobResult, file) => ({
  url: blobResult.url,
  pathname: blobResult.pathname,
  fileName: file?.name || blobResult.pathname?.split("/").pop() || "file",
  contentType: blobResult.contentType || file?.type || "",
});

const buildAuthHeaders = () => {
  const auth = localStorage.getItem("Token");
  return auth ? { Authorization: auth } : {};
};

const buildPathname = (file, folder = "rental-profile") => {
  const safeName = (file?.name || "file").replace(/\s+/g, "-");
  return `${folder}/${Date.now()}-${safeName}`;
};

export const uploadImageToBlob = async (file, folder = "rental-profile") => {
  const result = await upload(buildPathname(file, folder), file, {
    access: "public",
    handleUploadUrl: getImageUploadUrl(),
    headers: buildAuthHeaders(),
  });
  return toUploadedFileMeta(result, file);
};

export const uploadImagesToBlob = async (files, folder = "rental-profile") => {
  const list = Array.isArray(files) ? files : [];
  const uploaded = [];
  for (const file of list) {
    uploaded.push(await uploadImageToBlob(file, folder));
  }
  return uploaded;
};
